/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { StickySeverity } from "./StickySeverity";
import {
  StickySeverityFromJSON,
  StickySeverityFromJSONTyped,
  StickySeverityToJSON,
  StickySeverityToJSONTyped,
} from "./StickySeverity";
import type { StickyEntityType } from "./StickyEntityType";
import {
  StickyEntityTypeFromJSON,
  StickyEntityTypeFromJSONTyped,
  StickyEntityTypeToJSON,
  StickyEntityTypeToJSONTyped,
} from "./StickyEntityType";
import type { StickyCategory } from "./StickyCategory";
import {
  StickyCategoryFromJSON,
  StickyCategoryFromJSONTyped,
  StickyCategoryToJSON,
  StickyCategoryToJSONTyped,
} from "./StickyCategory";

/**
 *
 * @export
 * @interface Sticky
 */
export interface Sticky {
  /**
   *
   * @type {string}
   * @memberof Sticky
   */
  stickyId?: string;
  /**
   *
   * @type {StickyEntityType}
   * @memberof Sticky
   */
  entityType?: StickyEntityType;
  /**
   *
   * @type {string}
   * @memberof Sticky
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof Sticky
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof Sticky
   */
  description?: string;
  /**
   *
   * @type {StickyCategory}
   * @memberof Sticky
   */
  category?: StickyCategory;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Sticky
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Sticky
   */
  lastEditedBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Sticky
   */
  lastEditedAt?: OffsetDateTime;
  /**
   *
   * @type {StickySeverity}
   * @memberof Sticky
   */
  severity?: StickySeverity;
}

/**
 * Check if a given object implements the Sticky interface.
 */
export function instanceOfSticky(value: object): value is Sticky {
  return true;
}

export function StickyFromJSON(json: any): Sticky {
  return StickyFromJSONTyped(json, false);
}

export function StickyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Sticky {
  if (json == null) {
    return json;
  }
  return {
    stickyId: json["stickyId"] == null ? undefined : json["stickyId"],
    entityType:
      json["entityType"] == null
        ? undefined
        : StickyEntityTypeFromJSON(json["entityType"]),
    entityId: json["entityId"] == null ? undefined : json["entityId"],
    title: json["title"] == null ? undefined : json["title"],
    description: json["description"] == null ? undefined : json["description"],
    category:
      json["category"] == null
        ? undefined
        : StickyCategoryFromJSON(json["category"]),
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    lastEditedBy:
      json["lastEditedBy"] == null ? undefined : json["lastEditedBy"],
    lastEditedAt:
      json["lastEditedAt"] == null ? undefined : json["lastEditedAt"],
    severity:
      json["severity"] == null
        ? undefined
        : StickySeverityFromJSON(json["severity"]),
  };
}

export function StickyToJSON(json: any): Sticky {
  return StickyToJSONTyped(json, false);
}

export function StickyToJSONTyped(
  value?: Sticky | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    stickyId: value["stickyId"],
    entityType: StickyEntityTypeToJSON(value["entityType"]),
    entityId: value["entityId"],
    title: value["title"],
    description: value["description"],
    category: StickyCategoryToJSON(value["category"]),
    createdAt: value["createdAt"],
    lastEditedBy: value["lastEditedBy"],
    lastEditedAt: value["lastEditedAt"],
    severity: StickySeverityToJSON(value["severity"]),
  };
}
